module.exports = __webpack_public_path__ + "static/media/YF97_5.98a23cce.jpg";